  // export const apiPath = "http://localhost:8080/api";
  // export const apiPath = "http://olsdev-env.eba-8e36sgx8.ap-south-1.elasticbeanstalk.com/api";


export const apiPath = "https://backend.out-class.org/api";

                     
